<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1"><a id="text"></a>
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/motto.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" src="image/1_2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" src="image/1_21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer006">
<img alt="" class="_idGenObjectAttribute-1" src="image/3_4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer007">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/3_41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_205_20__206.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_205_20__2061.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-1" src="image/7_20__208new.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-1" src="image/7_20__208new1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" src="image/7_20__208b.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-1" src="image/blank2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" src="image/9_20__2010.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-1" src="image/9_20__20101.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-1" src="image/11_20__2012.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-1" src="image/11_20__20121.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_2013_20__2014.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_2013_20__20141.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_2015_20__2016.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-1" src="image/new_2015_20__20161.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-1" src="image/17_20__2018.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-1" src="image/17_20__20181.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" src="image/17_20__2018b.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-1" src="image/17_20__2018b1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-1" src="image/19_20__2020.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-1" src="image/19_20__20201.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-1" src="image/21_20__2022.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-1" src="image/21_20__2022.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-1" src="image/23_20__2024.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-1" src="image/23_20__20241.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-1" src="image/25_20__2026.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-1" src="image/25_20__20261.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-1" src="image/27_20__2028.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-1" src="image/27_20__2028.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-1" src="image/29_20__2030.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-1" src="image/29_20__20301.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" src="image/31_2032_20.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-1" src="image/31_2032_201.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-1" src="image/33_20__2034.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-1" src="image/33_20__20341.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-1" src="image/35_2036_20textonly.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer044">
<img alt="" class="_idGenObjectAttribute-1" src="image/35_2036_20textonly1.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-1" src="image/37_2038.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-1" src="image/37_20381.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-1" src="image/39_20__2040.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer048">
<img alt="" class="_idGenObjectAttribute-1" src="image/39_20__20401.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-1" src="image/41_20__2042.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer050">
<img alt="" class="_idGenObjectAttribute-1" src="image/41_20__20421.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-1" src="image/43_20__2044.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer052">
<img alt="" class="_idGenObjectAttribute-1" src="image/43_20__20441.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-1" src="image/45_20__2046.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer054">
<img alt="" class="_idGenObjectAttribute-1" src="image/45_20__20461.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-1" src="image/47_20__2048.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer056">
<img alt="" class="_idGenObjectAttribute-1" src="image/47_20__20481.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" src="image/49_20__2050.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer058">
<img alt="" class="_idGenObjectAttribute-1" src="image/49_20__20501.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-1" src="image/51_20__2052.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer060">
<img alt="" class="_idGenObjectAttribute-1" src="image/51_20__20521.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer061">
<img alt="" class="_idGenObjectAttribute-1" src="image/53_20__2054.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer062">
<img alt="" class="_idGenObjectAttribute-1" src="image/53_20__20541.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-1" src="image/55_20__2056.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer064">
<img alt="" class="_idGenObjectAttribute-1" src="image/55_20__2056.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-1" src="image/57_20__2058.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer066">
<img alt="" class="_idGenObjectAttribute-1" src="image/57_20__20581.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-1" src="image/59_20__2060.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer068">
<img alt="" class="_idGenObjectAttribute-1" src="image/59_20__20601.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-1" src="image/61_20__2062.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer070">
<img alt="" class="_idGenObjectAttribute-1" src="image/61_20__20621.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer071">
<img alt="" class="_idGenObjectAttribute-1" src="image/63_20__2064.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer072">
<img alt="" class="_idGenObjectAttribute-1" src="image/63_20__2064.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer073">
<img alt="" class="_idGenObjectAttribute-1" src="image/65_20__2066.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer074">
<img alt="" class="_idGenObjectAttribute-1" src="image/65_20__20661.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer075">
<img alt="" class="_idGenObjectAttribute-1" src="image/67_20__2068.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer076">
<img alt="" class="_idGenObjectAttribute-1" src="image/67_20__20681.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer077">
<img alt="" class="_idGenObjectAttribute-1" src="image/69_20__2070.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer078">
<img alt="" class="_idGenObjectAttribute-1" src="image/69_20__20701.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer079">
<img alt="" class="_idGenObjectAttribute-1" src="image/71_20__2072.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer080">
<img alt="" class="_idGenObjectAttribute-1" src="image/71_20__20721.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer081">
<img alt="" class="_idGenObjectAttribute-1" src="image/73_20__2074.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer082">
<img alt="" class="_idGenObjectAttribute-1" src="image/73_20__20741.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer083">
<img alt="" class="_idGenObjectAttribute-1" src="image/75_20__2076.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer084">
<img alt="" class="_idGenObjectAttribute-1" src="image/75_20__2076.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer085">
<img alt="" class="_idGenObjectAttribute-1" src="image/77_20__2078.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer086">
<img alt="" class="_idGenObjectAttribute-1" src="image/77_20__20781.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer087">
<img alt="" class="_idGenObjectAttribute-1" src="image/79_20__2080.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer088">
<img alt="" class="_idGenObjectAttribute-1" src="image/79_20__2080.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer089">
<img alt="" class="_idGenObjectAttribute-1" src="image/81_20__2082.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer090">
<img alt="" class="_idGenObjectAttribute-1" src="image/81_20__20821.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer091">
<img alt="" class="_idGenObjectAttribute-1" src="image/83_20__2084.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer092">
<img alt="" class="_idGenObjectAttribute-1" src="image/83_20__20841.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer093">
<img alt="" class="_idGenObjectAttribute-1" src="image/85_20__2086.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer094">
<img alt="" class="_idGenObjectAttribute-1" src="image/85_20__20861.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer095">
<img alt="" class="_idGenObjectAttribute-1" src="image/87_20__2088.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer096">
<img alt="" class="_idGenObjectAttribute-1" src="image/87_20__20881.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer097">
<img alt="" class="_idGenObjectAttribute-1" src="image/89_20__2090new.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer098">
<img alt="" class="_idGenObjectAttribute-1" src="image/89_20__2090new1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer099">
<img alt="" class="_idGenObjectAttribute-1" src="image/89_20__2090b.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer100">
<img alt="" class="_idGenObjectAttribute-1" src="image/89_20__2090b.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer101">
<img alt="" class="_idGenObjectAttribute-1" src="image/91_20__2092.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer102">
<img alt="" class="_idGenObjectAttribute-1" src="image/91_20__20921.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer103">
<img alt="" class="_idGenObjectAttribute-1" src="image/93_20__2094new.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer104">
<img alt="" class="_idGenObjectAttribute-1" src="image/93_20__2094new.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer105">
<img alt="" class="_idGenObjectAttribute-1" src="image/95_20__2096.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer106">
<img alt="" class="_idGenObjectAttribute-1" src="image/95_20__2096.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer107">
<img alt="" class="_idGenObjectAttribute-1" src="image/97_20__2098.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer108">
<img alt="" class="_idGenObjectAttribute-1" src="image/97_20__2098.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer109">
<img alt="" class="_idGenObjectAttribute-1" src="image/99_20__20100.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer110">
<img alt="" class="_idGenObjectAttribute-1" src="image/99_20__201001.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer111">
<img alt="" class="_idGenObjectAttribute-1" src="image/101_20__20102.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer112">
<img alt="" class="_idGenObjectAttribute-1" src="image/101_20__201021.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer113">
<img alt="" class="_idGenObjectAttribute-1" src="image/101_20__20102bnew.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer114">
<img alt="" class="_idGenObjectAttribute-1" src="image/101_20__20102bnew.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer115">
<img alt="" class="_idGenObjectAttribute-1" src="image/103_20__20104.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer116">
<img alt="" class="_idGenObjectAttribute-1" src="image/103_20__201041.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer117">
<img alt="" class="_idGenObjectAttribute-1" src="image/105_20__20106.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer118">
<img alt="" class="_idGenObjectAttribute-1" src="image/105_20__201061.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer119">
<img alt="" class="_idGenObjectAttribute-1" src="image/107_20__20108.png"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer120">
<img alt="" class="_idGenObjectAttribute-1" src="image/107_20__20108.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer121">
<img alt="" class="_idGenObjectAttribute-1" src="image/110.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer123" style="margin-top: 2em;"><a id="feed"></a>
<p class="ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" lang="en-US" xml:lang="en-US">Sharing your thoughts can help us improve our ebooks. We would appreciate your feedback. Thank you!</span></p>
<p class="ParaOverride-1" lang="en-GB" xml:lang="en-GB"> </p>
<p class="ParaOverride-1" lang="en-GB" xml:lang="en-GB"><a href="mailto:ebooks@amuniversal.com?subject=9781449480288"><span class="CharOverride-1" lang="en-US" xml:lang="en-US">ebooks@amuniversal.com</span></a></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer122">
<img alt="" class="_idGenObjectAttribute-1" src="image/111_20__20112.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-2" id="_idContainer124">
<p class="Normal ParaOverride-2"><a id="copy"></a><span class="CharOverride-2">The Trouble with Women </span><span class="CharOverride-3">copyright © 2016 by Jacky Fleming. <br/>All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. </span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Andrews McMeel Publishing</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">a division of Andrews McMeel Universal</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">1130 Walnut Street, Kansas City, Missouri 64106</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><a href="http://www.andrewsmcmeel.com" target="_blank"><span class="CharOverride-3">www.andrewsmcmeel.com</span></a></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">First printed in Great Britain by Square Peg, a part of the<br/>Penguin Random House group of companies.</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Jacky Fleming has asserted her right to be identified<br/> as the author of this work in accordance with<br/> the Copyright, Designs, and Patents Act 1988.</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">ISBN: 97</span><span class="CharOverride-3">8</span><span class="CharOverride-3">-1</span><span class="CharOverride-3">-</span><span class="CharOverride-3">4</span><span class="CharOverride-3">49</span><span class="CharOverride-3">4</span><span class="CharOverride-3">-8028-8</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Library of Congress Control Number:  2016936004</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Editor: Patty Rice</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Art Director: Julie Barnes</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Production Manager: Tamara Haus</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Production Editor: Erika Kuster</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Ebook Developer: Kristen Minter</span></p>
<p class="Normal ParaOverride-2"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">ATTENTION: SCHOOLS AND BUSINESSES</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-3">Andrews McMeel books are available at quantity discounts with <br/>bulk purchase for educational, business, or sales promotional use. <br/>For information, please e-mail the Andrews McMeel Publishing <br/>Special Sales Department: </span><a href="mailto:specialsales@amuniversal.com"><span class="CharOverride-3">specialsales@amuniversal.com</span></a><span class="CharOverride-3">.</span></p>
</div>
<div class="pagebreak"> </div>
<div class="Basic-Text-Frame" id="_idContainer127">
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><a id="other"></a><span class="CharOverride-4">Check out these other great titles from<br/> Andrews McMeel Publishing!</span></p>
</div>
<div class="_idGenObjectLayout-1n">
<a href="http://www.andrewsmcmeel.com/catalog/detail?sku=9781449471705" target="_blank">
<img alt="" class="thumb" src="image/9781449471705.jpg" style="width: 35%;"/>
</a>
<a href="http://www.andrewsmcmeel.com/catalog/detail?sku=9781449449728
" target="_blank">
<img alt="" class="thumb" src="image/9781449451783.jpg" style="width: 35%;"/>
</a>
</div>
<div class="_idGenObjectLayout-1n">
<a href="http://www.andrewsmcmeel.com/catalog/detail?sku=9781449466008" target="_blank">
<img alt="" class="thumb" src="image/9781449466008.jpg" style="width: 35%;"/>
</a>
<a href="http://www.andrewsmcmeel.com/catalog/detail?sku=9780740797415" target="_blank">
<img alt="" class="thumb" src="image/9781449460808.jpg" style="width: 35%;"/>
</a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Troublewithwomen_mobi_epub.vue?b2de3988